/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvCollapsibleSignature {
  Args: {
    expandOnPrint?: boolean;
    growDelay?: number;
    id?: string;
    open: boolean;
    overflowHidden?: boolean;
  };
  Blocks: {
    default: [BvCollapsibleSignature['Args']['open']];
  };
  Element: HTMLElement;
}

const BvCollapsibleComponent = templateOnlyComponent<BvCollapsibleSignature>();

export default BvCollapsibleComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvCollapsible: typeof BvCollapsibleComponent;
    'bv-collapsible': typeof BvCollapsibleComponent;
  }
}
